module.exports = __webpack_public_path__ + "img/cover.f291c163.webp";